<template>
  <div class="d2-layout-header-aside-group" :style="styleLayoutMainGroup" :class="{ grayMode: grayActive }">
    <!-- 半透明遮罩 -->
    <div class="d2-layout-header-aside-mask"></div>
    <!-- 主体内容 -->
    <div class="d2-layout-header-aside-content" flex="dir:top">
      <!-- 顶栏 -->
      <div class="d2-theme-header" :style="{
        opacity: this.searchActive ? 0.5 : 1
      }" flex-box="0" flex>
        <div class="logo-group" :style="{ width: asideCollapse ? asideWidthCollapse : asideWidth }" flex-box="0">
          <img v-if="asideCollapse" :src="`${$baseUrl}image/theme/${themeActiveSetting.name}/logo/icon-only.png`">

          <img v-else :src="`${$baseUrl}image/theme/${themeActiveSetting.name}/logo/login-logo.png`">
          <!-- <img v-else
               :src="`${$baseUrl}image/theme/${themeActiveSetting.name}/logo/all.png`"> -->
        </div>
        <div class="toggle-aside-btn" @click="handleToggleAside" flex-box="0">
          <d2-icon name="bars" />
        </div>
        <d2-menu-header flex-box="1" />
        <!-- 顶栏右侧 -->
        <div class="d2-header-right" flex-box="0">
          <!-- 如果你只想在开发环境显示这个按钮请添加 v-if="$env === 'development'" -->
          <!-- <d2-header-search @click="handleSearchClick"/>
          <d2-header-error-log/>
          <d2-header-fullscreen/>
          <d2-header-theme/>
          <d2-header-size/> -->
          <div class="d2-header-feature">
            <div>
              <el-tooltip class="item" effect="dark" content="刷新" placement="bottom">
                <el-button @click="handleRefresh" size="mini" icon="el-icon-refresh" circle />
              </el-tooltip>
            </div>
            <div>
              <el-tooltip class="item" effect="dark" content="全屏" placement="bottom">
                <el-button @click="handleFullScreen" size="mini" icon="el-icon-full-screen" circle />
              </el-tooltip>
            </div>
          </div>
          <d2-header-user />
        </div>
      </div>
      <!-- 下面 主体 -->
      <div class="d2-theme-container" flex-box="1" flex>
        <!-- 主体 侧边栏 -->
        <div flex-box="0" ref="aside" class="d2-theme-container-aside" :style="{
          width: asideCollapse ? asideWidthCollapse : asideWidth,
          opacity: this.searchActive ? 0.5 : 1
        }">
          <d2-menu-side />
        </div>
        <!-- 主体 -->
        <div class="d2-theme-container-main" flex-box="1" flex>
          <!-- 搜索 -->
          <transition name="fade-scale">
            <div v-show="searchActive" class="d2-theme-container-main-layer" flex="dir:top">
              <d2-panel-search ref="panelSearch" @close="searchPanelClose" />
            </div>
          </transition>
          <!-- 内容 -->
          <transition name="fade-scale">
            <div v-show="!searchActive" class="d2-theme-container-main-layer" flex="dir:top">
              <!-- tab -->
              <div class="d2-theme-container-main-header" flex-box="0">
                <!-- <d2-tabs /> -->
              </div>
              <!-- 页面 -->
              <div class="d2-theme-container-main-body" flex-box="1">
                <transition :name="transitionActive ? 'fade-transverse' : ''">
                  <keep-alive :include="keepAlive">
                    <router-view />
                  </keep-alive>
                </transition>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import d2HeaderSize from "./components/header-size";
import { mapState, mapGetters, mapActions } from "vuex";
import mixinSearch from "./mixins/search";
export default {
  name: "d2-layout-header-aside",
  mixins: [mixinSearch],
  components: {
    "d2-menu-side": () => import("./components/menu-side"),
    "d2-menu-header": () => import("./components/menu-header"),
    "d2-tabs": () => import("./components/tabs"),
    "d2-header-fullscreen": () => import("./components/header-fullscreen"),
    "d2-header-search": () => import("./components/header-search"),
    d2HeaderSize,
    "d2-header-theme": () => import("./components/header-theme"),
    "d2-header-user": () => import("./components/header-user"),
    "d2-header-error-log": () => import("./components/header-error-log"),
  },
  data() {
    return {
      // [侧边栏宽度] 正常状态
      asideWidth: "200px",
      // [侧边栏宽度] 折叠状态
      asideWidthCollapse: "65px",
    };
  },
  computed: {
    ...mapState("d2admin", {
      keepAlive: (state) => state.page.keepAlive,
      grayActive: (state) => state.gray.active,
      transitionActive: (state) => state.transition.active,
      asideCollapse: (state) => state.menu.asideCollapse,
    }),
    ...mapGetters("d2admin", {
      themeActiveSetting: "theme/activeSetting",
    }),
    /**
     * @description 最外层容器的背景图片样式
     */
    styleLayoutMainGroup() {
      return {
        ...(this.themeActiveSetting.backgroundImage
          ? {
            backgroundImage: `url('${this.$baseUrl}${this.themeActiveSetting.backgroundImage
              }')`,
          }
          : {}),
      };
    },
    ...mapState("d2admin/page", ["opened", "current"]),
  },
  methods: {
    ...mapActions("d2admin/menu", ["asideCollapseToggle"]),
    /**
     * 接收点击切换侧边栏的按钮
     */
    handleToggleAside() {
      this.asideCollapseToggle();
    },
    /**
     * 刷新页面
     */
    handleRefresh(event) {
      const page = this.opened.find((page) => page.fullPath === this.current);
      this.$router.push({ name: 'redirect/carfleetConfig' })
      setTimeout(() => {
        // if (!Object.keys(page).length === 0) {
        this.$router.push({ name: page.name });
        // }
      }, 100);
    },
    /**
     * 全屏事件
     */
    handleFullScreen() {
      if (!document.fullscreenElement) {
        // 进入全屏模式
        let element = document.documentElement;
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.webkitRequestFullscreen) {
          element.webkitRequestFullscreen();
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen();
        }
      } else {
        // 退出全屏模式
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }
    }
  },
};
</script>

<style lang="scss">
// 注册主题
@import "~@/assets/style/theme/register.scss";
</style>
